const Footer = () => {
  return <h1>My Footer</h1>;
};

export default Footer;
